"use client";

import * as React from "react";
import {
  PhoneInput as InternationalPhoneInput,
  type CountryData,
  type CustomFlagImage,
  type PhoneInputProps as InternationalPhoneInputProps,
  type PhoneInputRefType,
} from "react-international-phone";
import { cn } from "@/lib/utils";

const UKRAINE_ONLY_COUNTRIES: CountryData[] = [
  ["Ukraine", "ua", "380", "(..) ... .. .."],
];

const UKRAINE_FLAG: CustomFlagImage[] = [
  { iso2: "ua", src: "/flags/ua.svg" },
];

interface PhoneInputProps
  extends Omit<
    InternationalPhoneInputProps,
    "defaultCountry" | "preferredCountries" | "forceDialCode" | "inputProps"
  > {
  id?: string;
  autoComplete?: string;
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
  "aria-invalid"?: boolean;
  "aria-describedby"?: string;
  "aria-labelledby"?: string;
  size?: "sm" | "default";
}

const PhoneInput = React.forwardRef<PhoneInputRefType, PhoneInputProps>(
  function PhoneInput(
    {
      className,
      size = "default",
      id,
      autoComplete,
      inputMode,
      "aria-invalid": ariaInvalid,
      "aria-describedby": ariaDescribedBy,
      "aria-labelledby": ariaLabelledBy,
      ...props
    },
    ref,
  ) {
    return (
      <InternationalPhoneInput
        ref={ref}
        defaultCountry="ua"
        countries={UKRAINE_ONLY_COUNTRIES}
        flags={UKRAINE_FLAG}
        forceDialCode
        hideDropdown
        disableCountryGuess
        className={cn(
          "app-phone-input w-full",
          size === "sm" ? "app-phone-input--sm" : "app-phone-input--default",
          ariaInvalid && "app-phone-input--invalid",
          className,
        )}
        inputProps={{
          id,
          autoComplete,
          inputMode,
          "aria-invalid": ariaInvalid ? true : undefined,
          "aria-describedby": ariaDescribedBy,
          "aria-labelledby": ariaLabelledBy,
        }}
        {...props}
      />
    );
  },
);

PhoneInput.displayName = "PhoneInput";

export { PhoneInput };
